<template>
    <div>
        <div class="controls">
            <ds-dropdown class="dropdown" position="bottom-end">
                <button class="icon-only">
                    <ds-icon data-qa="drop-down" name="more-horizontal" />
                </button>

                <div slot="menu">
                    <ul class="dropdown-menu-list">
                        <li class="dropdown-menu-item" data-qa="delete-contact" @click="showConfirmModal">
                            <ds-icon class="menu-item-icon" name="trash-2" />
                            Delete contact
                        </li>

                        <li
                            class="dropdown-menu-item"
                            @click="contactLayout"
                        >
                            <ds-icon class="menu-item-icon" name="settings" />
                            Customize contact record
                        </li>
                    </ul>
                </div>
            </ds-dropdown>

            <ds-filled-button
                data-qa="update-contact"
                type="submit"
                @click="saveFromCustomHeader"
            >
                Save
            </ds-filled-button>

            <delete-contact
                ref="confirmModal"
                :contact-id="contactId"
            />
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import DeleteContact from './DeleteContact';

export default {
    components: {
        DeleteContact,
    },

    props: {
        customWatcherMap: [Map, Object],
        contactId: [String, Number],
        customTabMap: [Map, Object],
        tabId: [String, Number],
    },

    data() {
        return {
            buttonActionName: '',
            customFields: new Map(),
            contactRecordDetails: {},
            isUpdateCustomTab: false,
            customTabList: [],
            isContactLayoutEnabled: false,
        };
    },

    created() {
        this.load();
    },

    mounted() {
        this.$root.$on('SAVE_CUSTOM_FIELD', (actionItem) => {
            this.handleCustomFieldSave(actionItem);
        });
    },

    beforeDestroy() {
        this.$root.$off('SAVE_CUSTOM_FIELD');
    },

    methods: {
        handleCustomFieldSave(actionItem) {
            for (const key in [...this.customWatcherMap.entries()]) {
                if ([...this.customWatcherMap.entries()][key]) {
                    const isTabDataChanged = [...this.customWatcherMap.entries()][key];

                    if (isTabDataChanged[1] === true) {
                        this.isUpdateCustomTab = true;
                        break;
                    }
                }
            }

            this.buttonActionName = actionItem;

            if (this.isUpdateCustomTab) {
                this.updateCustomFields();
            } else {
                this.pageRedirect(this.buttonActionName);
            }
        },

        pageRedirect(actionItem) {
            if (actionItem === 'TOGGLE') {
                this.$root.$emit('CONTACT_TOGGLE', true);
            }

            if (actionItem === 'CLOSE_BUTTON') {
                this.$root.$emit('BACK_BUTTON', true);
            }
        },

        saveFromCustomHeader() {
            const customTab = {};
            const tabList = [];

            if (this.customWatcherMap.get(this.tabId)) {
                customTab.customTabs = this.customTabMap.get(this.tabId).customTabs;
                customTab.formFields = this.customTabMap.get(this.tabId).formFields;

                tabList.push(customTab);

                this.saveCustomFields(tabList);
                this.customWatcherMap.set(this.tabId, false);

                let flag = false;

                for (const key in [...this.customWatcherMap.entries()]) {
                    if ([...this.customWatcherMap.entries()][key]) {
                        const isTabDataChanged = [...this.customWatcherMap.entries()][key];

                        if (isTabDataChanged[1] === true) {
                            flag = true;
                            break;
                        }
                    }
                }
                this.$root.$emit('IS_CONTACT_CUSTOMFIELD_CHANGED', flag);
                this.$root.$emit('RESET_CUSTOM_FIELD_COPY', true);
            }
        },

        async updateCustomFields() {
            try {
                for (const key in [...this.customWatcherMap.entries()]) {
                    if ([...this.customWatcherMap.entries()][key]) {
                        const customTab = {};

                        customTab.customTabs = [...this.customTabMap.entries()][key][1].customTabs;
                        customTab.formFields = [...this.customTabMap.entries()][key][1].formFields;

                        this.customTabList.push(customTab);
                    }
                }
                this.saveCustomFields(this.customTabList);

                this.customWatcherMap.clear();
                this.isUpdateCustomTab = false;
                this.$root.$emit('IS_CONTACT_CUSTOMFIELD_CHANGED', false);
                this.pageRedirect(this.buttonActionName);
            } catch (error) {
                this.$error({ message: 'Something went wrong and we couldn\'t save this custom fields. Please try again.' });
            }
        },

        async saveCustomFields(customFieldsList) {
            const message = 'Saved custom fields';

            await axios.put(`/app/customFields/saveCustomFieldsData?contactId=${this.contactId}`, customFieldsList);

            this.$toast({ message });
        },

        showConfirmModal() {
            this.$refs.confirmModal.showModal();
        },

        contactLayout() {
            if (this.isContactLayoutEnabled) {
                this.$root.$emit('DISABLE_SWAP_IN_CUSTOMIZED_CONTACT_RECORD', true);
                this.$root.$emit('CUSTOMIZED_CONTACT_RECORD', true);
            }
        },

        async load() {
            this.getFeatureFlagValue();
        },

        async getFeatureFlagValue() {
            try {
                const response = await axios.get('/app/contact/isContactLayoutEnabled');

                this.isContactLayoutEnabled = response.data;
            } catch (e) {
                this.$error({ message: 'Unable get featureFlag value' });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.controls {
    display: flex;
    justify-content: flex-end;
    margin-top: $spacing-200;

    > *:first-child {
        @include margin-end(12px);
    }
}
</style>
